
export interface IPortalConfigurationHelperProps {
    
}

export const PortalConfigurationHelperPropsInitial: IPortalConfigurationHelperProps = { 
};